import { FilePondModule } from 'ngx-filepond';
import { VSTVArchivTable, VSTVPaket, VSTVService, VSTVZipLinkResponse } from './../services/vstv.service';
import { AfterViewInit, Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { ComponentFactoryResolver, Injector, SimpleChange, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, of, toArray } from 'rxjs';
import { merge, Observable, of as observableOf, pipe } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { FormControl } from '@angular/forms';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { MandatService, Mandat, MandatTable } from '../services/mandat.service';

import { PhutureIavatarComponent } from '../@components/phuture-iavatar/phuture-iavatar.component';

import { environment } from '../../environments/environment';
import { Logger } from '@core';

import { AuthQuery } from '@app/auth/auth.query';

import { JournalService, MailService, Mail } from '@core';
import { Patch } from 'immer';

import { DataChangeVSTVService } from './changes-vstv.service';

declare var $: any;

interface PatchSize {
  viewValue: string;
}

export interface EmpFilter {
  name: string;
  options: string[];
  defaultValue: string;
}

export interface filterOption {
  name: string;
  value: string;
  isdefault: boolean;
}

@Component({
  templateUrl: './vstv.component.html',
  styleUrls: [
    './vstv.component.scss',
    //'../../assets/dk/css/libs.bundle.css',
    //'../../assets/dk/css/theme.bundle.css'
  ],
})
export class VSTVComponent implements OnInit {
  displayedColumns: string[] = [
    'select',
    //'Md_PrimKey',
    'Md_Status',
    'Md_BelegNr',
    'bom',

    'Md_StatusDate',
    'Md_StatusTime',

    'Md_KzLand',
    'Md_KzBezirk',
    'Md_KzNummer',

    'Md_Hersteller',

    'Md_TatbestNr',

    //'Md_Betrag',
    'person',

    'actions',

    /*
    Aktenzeichen
    Status
    Land
    Bezirk
    Nummer
    Hersteller
    Farbe
    Datum
    Tatzeit
    Strasse
    Hausnummer
    Tatbestand
    DienstNr
    Konkretisierung
    Betrag
    create_date
    create_time
    person
    printed
    printdate
    printcount
    transferred
    transferdate
    longitude
    latitude
    info1
    info2
    info3
    fahrzeugart
    zone
    ticketnr
    ticket_zeit
    notees
    internal_notes
    vstv_export
    vstv_packet
    vstv_ignore
    zusatz1
    zusatz2
    strafe
    dienstnr_stvo
     */
  ];

  imageStorage = environment.serverUrl + '/'; // images gehen über api

  visitorTable: MandatTable;

  totalItems: number;
  //visitors: Visitor[];

  //stats: VisitorStats;
  /*
  stat_nbr_visitors: Observable<number>;
  stat_nbr_exhibitors: Observable<number>;
  stat_nbr_appointments: Observable<number>;
  stat_nbr_registered: Observable<number>;
  stat_nbr_approved: Observable<number>;
  stat_nbr_fs_done: Observable<number>;
  */

  dataSubject = new BehaviorSubject<Mandat[]>([]);
  visitors$: Observable<Mandat[]>;
  dataSource = new MatTableDataSource<Mandat>();

  // Selection model for checkbox column
  selection = new SelectionModel<Mandat>(true, []);

  // Archiv table columns (same as displayedColumns but without 'select')
  displayedColumnsArchiv: string[] = this.displayedColumns.filter((col) => col !== 'select');

  isLoading = true;
  selectedTabIndex = 0;

  searchTerm$ = new BehaviorSubject<string>('');

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  pageSizes = [50, 100, 200, 500];

  searchValue: string;
  //searchKeywordFilter = new FormControl();

  stati: string[] = [
    'Alle',
    'Erfasst',
    'Teil-Erfasst',
    'Überfällig',
    'Bezahlt',
    'Anzeige',
    'Anzeige-Bezahlt',
    'Anzeige / Bezahlt',
    'Storno',
  ];
  streets: string[] = ['Alle', 'Flughafen Alee', 'Zufahrt ABC'];

  empFilters: EmpFilter[] = [];
  defaultValue = 'Alle';
  filterDictionary = new Map<string, string>();
  //dataSourceFilters = new MatTableDataSource();
  filters$ = new BehaviorSubject<string>('');

  //patch sizes
  patchsize: PatchSize[] = [
    { viewValue: '20' },
    { viewValue: '50' },
    { viewValue: '100' },
    { viewValue: '200' },
    { viewValue: '500' },
  ];

  // dilaog und sidenav
  openSidebar = false;
  @ViewChild('sidenav') sidenav;
  selectedVisitor: Mandat;
  @ViewChild('visitorContainer', { read: ViewContainerRef }) quizContainer: ViewContainerRef;
  current_mandat: Mandat;
  previewMandatId: number | null = null;
  private subscription: Subscription; // changes in the eg sidebar

  //
  //
  frmExport: FormGroup;
  frmExportArchiv: FormGroup;

  //
  //frmVSTVArchiv: FormGroup;
  selectedVSTVPaketID: number = 0;
  vstv_archiv_pakete: VSTVPaket[];
  popVSTVArchiv = new FormControl('');
  dsVSTVArchivMandate = new MatTableDataSource<any>(); // For the mat-table data
  //displayColVSTVArchivMandate: string[] = ['id', 'bezeichnung', 'status']; // Adjust according to your data
  // ----> displayedColumns von mdante

  constructor(
    private mandatService: MandatService,
    private VSTVService: VSTVService,
    private cfr: ComponentFactoryResolver,
    private _snackBar: MatSnackBar,
    private _fb: FormBuilder,
    private journalService: JournalService,
    public dialog: MatDialog,

    private injector: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private authQuery: AuthQuery,
    private dataChangeService: DataChangeVSTVService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    //this.empFilters.push({ name: 'Land', options: this.countries, defaultValue: this.defaultValue });
    //this.empFilters.push({ name: 'Status', options: this.stati, defaultValue: this.defaultValue });
    //this.empFilters.push({ name: 'Straße', options: this.streets, defaultValue: this.defaultValue });

    // reset the selected id
    this.selectedVSTVPaketID = 0;

    // subscribe to the sidebar changes
    this.subscription = this.dataChangeService.dataChanges$.subscribe((data) => {
      if (data) {
        // Handle the data, e.g., update the list or form
        console.log('change recieved-----------');
        console.log(data);

        // update the specific transfer
        this.updateMandat(data);
      }
    });

    // get selection change on the dropdown
    this.popVSTVArchiv.valueChanges.subscribe((value) => {
      // fetch the daata
      console.log('get mandate from paket ' + value);
      this.fetchMandateVSTVPaket(value);

      this.selectedVSTVPaketID = value;
    });

    // init the forms
    this.initForms();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe(); // unsubscibe to the subscriptions
  }

  initForms() {
    this.frmExport = this._fb.group({
      bearbeiter: [''],
    });

    this.frmExportArchiv = this._fb.group({
      bearbeiterErneut: [''],
    });

    // fill with user data
    var username = this.authQuery.name;
    const bearbeiterControl = this.frmExport.get('bearbeiter');
    if (bearbeiterControl && !bearbeiterControl.value) {
      this.frmExport.patchValue({ bearbeiter: '' + username });
    }
    const bearbeiterErneutControl = this.frmExportArchiv.get('bearbeiterErneut');
    if (bearbeiterErneutControl && !bearbeiterErneutControl.value) {
      this.frmExportArchiv.patchValue({ bearbeiterErneut: '' + username });
    }
  }

  /**
   * update the datasource with the given data from the subscription
   */
  updateMandat(updatetMandat: Mandat) {
    const data = this.dataSubject.getValue();
    const index = data.findIndex((visitor) => +visitor.Md_BelegNr === +updatetMandat.Md_BelegNr);
    if (index > -1) {
      data[index] = updatetMandat;
      this.dataSubject.next(data); // Update the BehaviorSubject
      this.dataSource.data = data; // Update the MatTableDataSource
    }
  }

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;

    // ----------------------------------------- MANDATE
    // get all the mandate for the table ansicht
    merge(
      this.filters$,
      this.searchTerm$.pipe(debounceTime(400), distinctUntilChanged()),
      this.sort.sortChange,
      this.paginator.page
    )
      .pipe(
        startWith({}),
        switchMap((term) => {
          this.isLoading = true;
          //var sTerm = term && typeof term == 'string' ? term.toString() : '';
          return this.getTableData$(
            this.paginator.pageIndex + 1,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction,
            //sTerm.trim(),
            this.searchTerm$.getValue(),
            this.filters$.getValue()
          ).pipe(catchError(() => observableOf(null)));
        }),
        map((visTable) => {
          if (visTable == null) return [];
          this.totalItems = visTable.total;
          this.isLoading = false;

          //this.stats = visTable.stats;

          return visTable.data.map((data) => {
            return <Mandat>{
              ...data,
              /*
              decharge_resp_civile: data.decharge_resp_civile == -1 ? 1 : 0,
              estimate: data.estimate == '-1' ? '1' : 0,
              garage_day1: data.garage_day1 == -1 ? 1 : 0,
              garage_day2: data.garage_day2 == -1 ? 1 : 0,
              lunch_day1: data.lunch_day1 == -1 ? 1 : 0,
              lunch_day2: data.lunch_day2 == -1 ? 1 : 0,
              attendance_event: data.attendance_event == -1 ? 1 : 0,
              hotel_stay_night: data.hotel_stay_night == -1 ? 1 : 0,
              transfer_arrival: data.transfer_arrival == -1 ? 1 : 0,
              transfer_return: data.transfer_return == -1 ? 1 : 0,
              flight_booked: data.flight_booked == -1 ? 1 : 0,
              */
            };
          });
          //return visTable.data;
        })
      )
      .subscribe((mandate: Mandat[]) => {
        this.visitors$ = of(mandate);
        this.dataSource = new MatTableDataSource(mandate);

        this.dataSubject.next(mandate);

        // Clear selection when data reloads
        this.selection.clear();

        //reset paginator
        //this.paginator.pageIndex = 1;
      });

    // ----------------------------------------- VSTV ARCHIV Pakete
    // get all the archiv pakete for the dropdown
    this.VSTVService.getVSTVArchivPakete().subscribe(
      (vstv_pakete: VSTVArchivTable) => {
        this.vstv_archiv_pakete = vstv_pakete.data;
      },
      (error) => {
        console.error('Error during sequential API calls:', error);
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchTerm$.next(filterValue);
  }

  get showNoResults(): boolean {
    return !this.isLoading && this.dataSource.data.length === 0;
  }

  goToArchiveTab(): void {
    this.selectedTabIndex = 1;
  }

  get showArchivNoPaketSelected(): boolean {
    return !this.selectedVSTVPaketID || +this.selectedVSTVPaketID <= 0;
  }

  /** Format the Md_TatbestNr JSON array to a readable vstv_code string */
  formatVSTVCode(tatbestNr: any): string {
    if (!tatbestNr) return '';
    try {
      const arr = typeof tatbestNr === 'string' ? JSON.parse(tatbestNr) : tatbestNr;
      if (Array.isArray(arr)) {
        return arr.join(', ');
      }
      return String(tatbestNr);
    } catch {
      return String(tatbestNr);
    }
  }

  applyEmpFilter(ob: MatSelectChange, empfilter: EmpFilter) {
    this.filterDictionary.set(empfilter.name, ob.value);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.filters$.next(jsonString);
  }

  /** Whether all rows are selected */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  /** Toggle select all / deselect all */
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach((row) => this.selection.select(row));
    }
  }

  getTableData$(pageNumber: Number, pageSize: Number, sort: string, order, searchTerm: string, filtersArgs: string) {
    // get data from server

    filtersArgs = '[["Status","Überfällig"]]';

    return this.mandatService.getMandate(pageNumber, pageSize, sort, order, searchTerm, filtersArgs);
  }

  /**
   * open a readonly preview of the given mandat in the slide-in offcanvas
   */
  openPreview(mandat_id: number) {
    console.log('open preview: ' + mandat_id);

    // find the row (current paket table or archiv table) for the offcanvas title
    let mandat = <Mandat>this.dataSource.filteredData.find((element: Mandat) => element.Md_PrimKey == mandat_id);
    if (!mandat) {
      mandat = <Mandat>this.dsVSTVArchivMandate.data.find((element: Mandat) => element.Md_PrimKey == mandat_id);
    }
    this.current_mandat = mandat;

    // set the id for the preview component and open the offcanvas
    this.previewMandatId = mandat_id;

    $('#staticBackdrop').offcanvas('show');
  }

  /**
   * close the readonly preview offcanvas
   */
  closePreview() {
    this.previewMandatId = null;
    $('#staticBackdrop').offcanvas('hide');
  }

  showVisitor(visitor: Mandat) {
    console.log('show the page');

    this.selectedVisitor = visitor;

    // load visitor - firststart
    //this.llStartPageEdit(visitor);
  }

  sidebarOnClose() {
    console.log('close');
    this.openSidebar = false;
  }

  /**
   * wenn der tab geklickt wird --< sollte man das dropdoewn refreshen -< wieder laden
   * @param event
   */
  onTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
    console.log('Selected Tab index: ', event.index);

    if (event.index === 1) {
      // das ist der zweite tab --> archiv
      this.VSTVService.getVSTVArchivPakete().subscribe(
        (vstv_pakete: VSTVArchivTable) => {
          this.vstv_archiv_pakete = vstv_pakete.data;

          this.cdr.detectChanges();
        },
        (error) => {
          console.error('Error during sequential API calls:', error);
        }
      );
    }
  }

  //
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //
  // ------------------------ ARCHIV
  //

  fetchMandateVSTVPaket(filterKey: string) {
    // get the data

    var filtersArgs = '[["VSTVPaket",' + filterKey + ']]';

    this.mandatService.getMandate(1, 50, 'Md_BelegNr', 'asc', '', filtersArgs).subscribe((retMandate: MandatTable) => {
      this.dsVSTVArchivMandate.data = retMandate.data;
    });
  }

  //
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //
  // ------------------------ VSTV FILE DOWNLOAD
  //

  /**
   *
   * generate the vstv to file
   * paket-nummer ist 0 -> wenn es neu erstellt wird -> sonst wieder erstellen
   */
  vstvlog: string = '';
  erneutDownload: boolean = false;
  generateVSTV(paket_id: number) {
    console.log('export vstv');

    let bearbeiter = this.frmExport.get('bearbeiter')?.value;

    if (paket_id > 0) this.erneutDownload = true; // wenn es wieder generiert wird - anderer log anzeigen
    // update to the server

    this.mandatService.doExportVSTV(bearbeiter, paket_id).subscribe(
      (response) => {
        //next() callback
        console.log('response received');

        this.vstvlog = response.log;
        this.paketID = response.paketid;
        this.vstv_file = response.vstvfile;

        // broadcast the changes back to the table-view
        //this.broadcastChanges(response);

        this._snackBar.open('VSTV Datei erfolgreich generiert.', 'Close', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        //
        // show some feedback --> snackbar ?
        //
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  vstv25log: string = '';
  erneutDownload25: boolean = false;
  generateVSTV25(paket_id: number) {
    console.log('export vstv25');

    let bearbeiter: string;
    if (paket_id > 0) {
      // Archiv-Tab: verwende bearbeiterErneut
      bearbeiter = this.frmExportArchiv.get('bearbeiterErneut')?.value;
    } else {
      // Aktuelles Paket Tab: verwende bearbeiter
      bearbeiter = this.frmExport.get('bearbeiter')?.value;
    }

    if (paket_id > 0) this.erneutDownload25 = true; // wenn es wieder generiert wird - anderer log anzeigen

    // Collect selected mandate IDs (only for new exports, not archiv re-exports)
    const selectedIds: number[] = paket_id === 0
      ? this.selection.selected.map((m) => +m.Md_PrimKey)
      : [];

    // update to the server
    this.mandatService.doExportVSTV25(bearbeiter, paket_id, selectedIds).subscribe(
      (response) => {
        //next() callback
        console.log('response received');

        this.vstv25log = response.log;
        this.paketID = response.paketid;
        this.vstv_file = response.vstvfile;

        this._snackBar.open('VSTV25 XML Datei erfolgreich generiert.', 'Close', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
      },
      () => {
        //complete() callback
        console.log('Request completed');
      }
    );
  }

  /**
   * Test Export: same as generateVSTV25 but with testMode=true
   * Replaces first char of Aktenzeichen with 'T' (PPLUS -> TPLUS, BOM -> TOM)
   */
  generateVSTV25Test(paket_id: number) {
    console.log('test export vstv25');

    const bearbeiter = this.frmExportArchiv.get('bearbeiterErneut')?.value || '';

    this.erneutDownload25 = true;

    this.mandatService.doExportVSTV25(bearbeiter, paket_id, [], true).subscribe(
      (response) => {
        console.log('test export response received');

        this.vstv25log = response.log;
        this.paketID = response.paketid;
        this.vstv_file = response.vstvfile;

        this._snackBar.open('Test Export (mit T-Prefix) erfolgreich generiert.', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      },
      (error) => {
        console.error('Test export failed with error', error);
        this._snackBar.open('Fehler beim Test Export.', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    );
  }

  downloadVSTV25(paketID: number) {
    this.mandatService.getVSTV25File(paketID).subscribe(
      (response) => {
        this._snackBar.open('VSTV25 XML Datei wird heruntergeladen.', 'Close', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      },
      (error) => {
        console.error('Download failed with error', error);
        this._snackBar.open('Fehler beim Download der VSTV25 Datei.', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    );
  }

  // find vstv-paket im archiv by id
  findVSTVPaketByID(array, id) {
    const item = array.find((element) => element.id === id);
    return item ? item.bezeichnung : 'not-found';
  }

  /**
   *
   * das übermittelte mandat soll aus dem paket ausgenommen werden
   * @param mandat
   */
  ausPaketAusnehmen(mandat: Mandat) {
    console.log(mandat);

    this.VSTVService.doPaketAusnehmen(mandat.Md_PrimKey).subscribe(
      (response: any) => {
        //next() callback
        console.log('response received');
        //console.log(response);

        // broadcast the changes back to the table-view
        //this.broadcastChanges(response);

        mandat.Md_Status = '8'; // auf ausgenommen setzten

        this._snackBar.open('Mandate erfolgreich ausgenommen.', 'Close', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        //
        // show some feedback --> snackbar ?
        //
        //alert('table refresh');
        this.ngAfterViewInit();
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  /**
   *
   * export vstv to file with given paket id
   */
  paketID: number;
  vstv_file: string;
  downloadVSTV(paketID: number, erneut: boolean = false) {
    console.log('download vstv paket# ' + paketID);

    // update to the server
    this.mandatService.downloadVSTVFile(paketID).subscribe(
      (blob) => {
        //next() callback
        console.log('response received');

        // bei einem erneutem export
        // muss die caption ermittelt werden
        if (erneut) {
          // es wird erneut exportiert
          const bezeichnung = this.findVSTVPaketByID(this.vstv_archiv_pakete, this.selectedVSTVPaketID);

          this.vstv_file = bezeichnung + '-' + Math.floor(1000 + Math.random() * 9000) + '.txt';
        }

        this.downloadBlob(blob, this.vstv_file);

        // broadcast the changes back to the table-view
        //this.broadcastChanges(response);

        this._snackBar.open('VSTV Datei erfolgreich generiert.', 'Close', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        //
        // show some feedback --> snackbar ?
        //
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a); // Append the element to the DOM to make it work in Firefox
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a); // Clean up
  }

  /**
   * Download VSTV images ZIP for the selected package - via public link
   */
  downloadVSTVImagesZip() {
    if (this.selectedVSTVPaketID <= 0) {
      this._snackBar.open('Bitte wählen Sie zuerst ein VSTV-Paket aus.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return;
    }

    console.log('Create VSTV images ZIP for package (link): ' + this.selectedVSTVPaketID);

    this.VSTVService.downloadVSTVImagesZipLink(this.selectedVSTVPaketID).subscribe(
      (resp: VSTVZipLinkResponse) => {
        // Show dialog with link; on close delete again
        const link = resp.url;
        const ref = this.dialog.open(SimpleLinkDialogComponent, {
          width: '520px',
          data: { title: 'Bilder-Archiv', url: link },
          disableClose: false,
        });

        ref.afterClosed().subscribe(() => {
          // delete the zip again
          this.VSTVService.deleteVSTVZip(resp.path_public || resp.url).subscribe({
            next: () => {
              this._snackBar.open('Bilder-Archiv-Link wurde entfernt.', 'Close', {
                duration: 1500,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            },
            error: () => {
              // ignore silently
            },
          });
        });
      },
      (error) => {
        //error() callback
        console.error('Request failed with error:', error);
        this._snackBar.open('Fehler beim Erzeugen des Bilder-Archivs: ' + error, 'Close', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      },
      () => {
        //complete() callback
        console.log('VSTV images ZIP link ready');
      }
    );
  }

  //
  // -------------------------------
}

// Simple inline dialog component to show a download link
@Component({
  selector: 'app-simple-link-dialog',
  template: `
  <h2 mat-dialog-title>{{ data?.title || 'Bilder-Paket' }}</h2>
  <mat-dialog-content>
    <p class="mb-2 font-medium">Bilder-Paket fertig zum Herunterladen.</p>
    <p class="text-sm text-gray-500 mb-0">Der Link wird beim Schließen dieses Dialogs entfernt.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <a mat-button color="primary" [href]="data?.url" target="_blank" rel="noopener">Bilder downloaden</a>
    <button mat-button mat-dialog-close>Schließen</button>
  </mat-dialog-actions>
  `,
})
export class SimpleLinkDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
